import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

export const configApi = createApi({
    reducerPath: 'configApi',
    baseQuery: baseQueryWithReauth,
    refetchOnFocus: true,
    refetchOnReconnect: true,
    endpoints: (builder) => ({
        getConfiguration: builder.query({
            query: () => ({
                url: 'config',
            }),
            providesTags: ['Configuration'],
        }),
        updateConfiguration: builder.mutation({
            query: (legend) => ({
                url: 'config',
                method: 'POST',
                body: { legend },
            }),
            invalidatesTags: ['Configuration'],
        }),
    }),
});

export const {
    useGetConfigurationQuery,
    useUpdateConfigurationMutation
} = configApi;
